import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'NavBar' })({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        overflowX: 'auto',
        scrollbarWidth: 'none',
        ['&::-webkit-scrollbar']: {
            display: 'none'
        }
    }
});
